// extracted by mini-css-extract-plugin
export default {"currency":"AddProductModal_currency__CMwQ-","price":"AddProductModal_price__pxS-n","name":"AddProductModal_name__MHjTI","rating":"AddProductModal_rating__tghcf"};